import moment from 'moment';

const useTimeCalculation = () => {
  const calculateEndTime = (startTime, workHours, lunchTime = '0', imputableColation = false) => {
    const totalWorkDuration = moment.duration(workHours);
    const collationDuration = moment.duration(lunchTime, 'minutes');

    // Solo agregamos el tiempo de colación si imputableColation es false (NO imputable)
    const totalDuration = imputableColation
      ? totalWorkDuration
      : moment.duration(totalWorkDuration).add(collationDuration);

    const start = moment.utc(startTime, 'HH:mm');
    const end = moment
      .utc(start)
      .add(totalDuration)
      .format('HH:mm');

    return end;
  };

  // Calcula la duración en minutos entre startLunch y endLunch (para colación horario pactado)
  const calculateLunchDuration = (startLunch, endLunch) => {
    if (!startLunch || !endLunch) return 0;
    const start = moment.utc(startLunch, 'HH:mm');
    const end = moment.utc(endLunch, 'HH:mm');
    const diff = end.diff(start, 'minutes');
    return diff > 0 ? diff : 0;
  };

  return { calculateEndTime, calculateLunchDuration };
};

export default useTimeCalculation;
